import _ from "lodash";
import {formatSnapshotString} from "./formatters";


export const getTooltipContent = ({
                                      seriesData,
                                      lastHoveredTimestamp,
                                      setLastHoveredTimestamp,
                                      setLastHoveredPoint,
                                      showSnapshotTooltip,
                                      precision
                                  }) => {
    return function () {
        const hoveredTimestamp = this.x;
        const matchingDataPoint = seriesData.find(point => new Date(point[0]).getTime() === hoveredTimestamp);
        if (matchingDataPoint && Array.isArray(matchingDataPoint) && matchingDataPoint.length > 2) {
            if (hoveredTimestamp !== lastHoveredTimestamp) {
              setLastHoveredTimestamp(hoveredTimestamp);
              const copiedSnapshot = _.cloneDeep(matchingDataPoint[2]);
              setLastHoveredPoint({...copiedSnapshot});
            }
            if (showSnapshotTooltip) {
                return formatSnapshotString(...matchingDataPoint);
            }
            return `${this?.seriesName} ${this?.value?.toFixed(2)}`;
        } else {
          return `Value: ${this?.value?.toFixed?.(precision) ?? '--'}`;
        }
    }

};